import { cloneDeep } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { FORM_NAME } from "src/constant/common";

const FieldValue = ({ field, mcsCriteriaObj }) => {
  const { key, title, label, unit } = field;

  const value = mcsCriteriaObj?.[key]?.value;

  return (
    <div className="fw-bold mb-3">
      <h5 className="fw-bold mb-3">{title}</h5>
      <div className="ms-2 mb-3">
        <span>{`${label} ${value}`}</span>
        {unit && <span> ({unit})</span>}
      </div>
    </div>
  );
};

const MCSCriteria = ({ simulationData }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  const simulationDataClone = cloneDeep(simulationData);

  const MCSCriteriaData = [
    {
      key: `${FORM_NAME.MCS.ALTITUDE_REFERENCE}`,
      title: t(`new.MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}`),
      label: t(`new.MCS.${FORM_NAME.MCS.ALTITUDE_REFERENCE}_text`),
      unit: "m",
    },
    {
      key: `${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`,
      title: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}`),
      label: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_POSITION_REFERENCE}_text`),
      unit: "m",
    },
    {
      key: `${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`,
      title: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}`),
      label: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_POSITION_REFERENCE}_text`),
      unit: "m",
    },
    {
      key: `${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`,
      title: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}`),
      label: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_VELOCITY_REFERENCE}_text`),
      unit: "m/s",
    },
    {
      key: `${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`,
      title: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}`),
      label: t(`new.MCS.${FORM_NAME.MCS.EAST_WEST_VELOCITY_REFERENCE}_text`),
      unit: "m/s",
    },
    {
      key: `${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`,
      title: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}`),
      label: t(`new.MCS.${FORM_NAME.MCS.NORTH_SOUTH_VELOCITY_REFERENCE}_text`),
      unit: "m/s",
    },
    { key: `${FORM_NAME.MCS.ROLL_ANGLE}`, title: t(`new.MCS.${FORM_NAME.MCS.ROLL_ANGLE}`), label: t(`new.MCS.${FORM_NAME.MCS.ROLL_ANGLE}_text`), unit: "deg" },
    { key: `${FORM_NAME.MCS.PITCH_ANGLE}`, title: t(`new.MCS.${FORM_NAME.MCS.PITCH_ANGLE}`), label: t(`new.MCS.${FORM_NAME.MCS.PITCH_ANGLE}_text`), unit: "deg" },
    { key: `${FORM_NAME.MCS.YAW_ANGLE}`, title: t(`new.MCS.${FORM_NAME.MCS.YAW_ANGLE}`), label: t(`new.MCS.${FORM_NAME.MCS.YAW_ANGLE}_text`), unit: "deg" },
    { key: `${FORM_NAME.MCS.ROLL_RATE}`, title: t(`new.MCS.${FORM_NAME.MCS.ROLL_RATE}`), label: t(`new.MCS.${FORM_NAME.MCS.ROLL_RATE}_text`), unit: "deg/s" },
    { key: `${FORM_NAME.MCS.PITCH_RATE}`, title: t(`new.MCS.${FORM_NAME.MCS.PITCH_RATE}`), label: t(`new.MCS.${FORM_NAME.MCS.PITCH_RATE}_text`), unit: "deg/s" },
    { key: `${FORM_NAME.MCS.YAW_RATE}`, title: t(`new.MCS.${FORM_NAME.MCS.YAW_RATE}`), label: t(`new.MCS.${FORM_NAME.MCS.YAW_RATE}_text`), unit: "deg/s" },
  ];

  const mcsCriteriaObj = simulationDataClone?.input_data?.MCS;

  return (
    <div className="m-3">
      {MCSCriteriaData.map((field) => (
        <FieldValue field={field} mcsCriteriaObj={mcsCriteriaObj} key={field.key} />
      ))}
    </div>
  );
};

export default MCSCriteria;
